
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[...uri]",
      function () {
        return require("private-next-pages/event/[...uri].jsx");
      }
    ]);
  